import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import * as pbi from "powerbi-client";
import { makeStyles } from "@material-ui/core/styles";
import PowerBIService from "../../services/console_services/PowerBi";
import Loading from "../../common/Components/Loading";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";

const useStyles = makeStyles(() => ({
  fullScreenContainer: {
    height: "calc(100vh - 94px)",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "0",
    background: "#fff",
  },
  embedContainer: {
    height: "100%",
    width: "100%",
    borderRadius: "6px",
    boxShadow: "0 0 6px #ddd",
    overflow: "hidden",
    ["& iframe"]: {
      border: "none",
      height: "100%",
      width: "100%",
    },
  },
}));

const PowerBIReportEmbed = (selectedPowerData) => {
  const classes = useStyles();
  const { instance } = useMsal();
  const [powerBIData, setPowerBIData] = useState(null);
  const [loading, setLoading] = useState(true);
  const store = useSelector((state) => state);
  const { models } = pbi;
  const entityType = store?.viewPowerBi?.viewPowerBiData;
  console.log("entityType: ", entityType);

  const REPORTS = {
    DOM: {
      reportId: "7141c843-b6eb-4624-b40d-01828fe884dd",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    SNO: {
      reportId: "418c8818-96d1-40bd-8972-e6ec5daeb6f6",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "Deployment Optimization": {
      reportId: "0d7516d4-820d-4ece-a749-1f67fd41d15f",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "Deployment Planning_Payload": {
      reportId: "1661ff98-b4e0-49da-b5d2-31091e42fe5b",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "Deployment Planning": {
      reportId: "127b6fe6-176c-4693-9162-1bc678c12006",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "Capacity Planning": {
      reportId: "6e7eabf9-e45d-4de7-b9cf-7a442fe49d40",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    CP: {
      reportId: "6e7eabf9-e45d-4de7-b9cf-7a442fe49d40",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    Distribution_Planning: {
      reportId: " b18d3ab2-66d3-4b40-b276-bb176ae773d4",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    Distribution_Planning_Payload: {
      reportId: "bc3db767-0e8f-4154-94bc-43beb3386f13",
      groupId: "018e90b6-62f3-4d02-a3b3-d1a160b1bc58",
    },
    KPI_DO: {
      reportId: "0b3c0fb8-efe7-48af-a5cf-fa7be63c5d36",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    CP_SNO: {
      reportId: "1661ff98-b4e0-49da-b5d2-31091e42fe5b",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    FGS: {
      reportId: "ecb623b5-2f96-4978-aed0-c98ac850ef87",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "CP Main Report": {
      reportId: " b18d3ab2-66d3-4b40-b276-bb176ae773d4",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    RDP: {
      reportId: "5e8853b5-47c2-4647-b4d1-1b0442de7df9",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "RDP Frozen": {
      reportId: "28ef48bc-249c-4979-a95a-b677170189",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "RDP NPW": {
      reportId: "0418e091-c899-43c6-a24e-156725d37f95",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "RDP Chilled": {
      reportId: "efa5a5e2-5a12-4716-ac06-694c7d7c31d8",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "Potential Out Of Stock": {
      reportId: "5d82a205-9611-45ed-a9aa-de9718c863ed",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    POOS: {
      reportId: "5d82a205-9611-45ed-a9aa-de9718c863ed",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    DETENTION: {
      reportId: "10521b53-37e5-43b4-853f-7d626ef0e78a",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "RCA Historic": {
      reportId: "2d31c070-70be-482d-aaf3-6b1adf3872a2",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "Operational Account": {
      reportId: "10521b53-37e5-43b4-853f-7d626ef0e78a",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    "Historical Customer Facing": {
      reportId: "b0ebfbe0-571a-4530-8658-41e45728f616",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    FF: {
      reportId: "c05bc48b-8872-4e1a-aacd-5a8ea5d724c7",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    RR: {
      reportId: "d819dd37-2b79-4917-b298-71f135dd1695",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    NPS: {
      reportId: "e5333f4b-53d0-4bb9-89b3-fbe5de7c09b9",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    SLP: {
      reportId: "0a756e04-9272-410d-bb6d-d1fedc71965e",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    IOF: {
      reportId: "ce2c9f41-80ee-419e-8faf-6e553aac4888",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
    IOFPB: {
      reportId: "f61d9a7f-1138-478c-a008-37c016c85c05",
      groupId: "fdfa7e7d-e8b0-4c83-8a94-73a9c7a89091",
    },
  };
  const tabName = store?.tabs?.tabName;
  useEffect(() => {
    const module = store?.viewPowerBi?.deepDriveTab
      ? store?.viewPowerBi?.deepDriveTab
      : tabName || "DOM";

    // console.log(module, "module");

    let groupId;
    let reportId;
    if (entityType?.Metric === "Payload_reduction") {
      groupId = REPORTS["Deployment Planning_Payload"]?.groupId || null;
      reportId = REPORTS["Deployment Planning_Payload"]?.reportId || null;
    } else if (entityType?.Metric === "Waste Risk" && module !== "FGS") {
      groupId = REPORTS["Distribution_Planning_Payload"]?.groupId || null;
      reportId = REPORTS["Distribution_Planning_Payload"]?.reportId || null;
    } else if (
      module === "DIP" &&
      (entityType?.Metric === "LT-Over Utilization" ||
        entityType?.Metric === "LT-Under Utilization" ||
        entityType?.Metric === "ST-Over Utilization" ||
        entityType?.Metric === "ST-Under Utilization" ||
        entityType?.Metric === "Throughput")
    ) {
      console.log("inside else DIP");

      groupId = REPORTS["Distribution_Planning"]?.groupId || null;
      reportId = REPORTS["Distribution_Planning"]?.reportId || null;
    } else if (
      selectedPowerData?.selectedPowerData === true &&
      !(typeof selectedPowerData.selectedPowerData === "object")
    ) {
      groupId = REPORTS["KPI_DO"]?.groupId || null;
      reportId = REPORTS["KPI_DO"]?.reportId || null;
    } else if (
      entityType?.Metric === "cost_per_case" &&
      entityType?.Module === "SNO"
    ) {
      groupId = REPORTS["CP_SNO"]?.groupId || null;
      reportId = REPORTS["CP_SNO"]?.reportId || null;
    } else {
      // console.log("inside else", REPORTS[module]?.reportId, REPORTS[module]);
      groupId = REPORTS[module]?.groupId || null;
      reportId = REPORTS[module]?.reportId || null;
    }
    setLoading(true);
    if (groupId && reportId) {
      PowerBIService.getPowerBi(groupId, reportId, instance)
        .then((response) => {
          if (response) {
            setPowerBIData(response);
          }
        })
        .catch((error) => console.error("Error fetching Power BI data:", error))
        .finally(() => setLoading(false));
    }
  }, []);

  async function setSlicers() {
    const tabName = store?.tabs?.tabName; // Dynamically selected tab name
    const report = window?.report;
    if (!report) {
      return;
    }

    // console.log("tabName123: ", tabName, entityType);

    try {
      const pages = await report.getPages();
      console.log("pages>>>>>>>>>>>>>>", pages);
      if (!pages || pages.length < 4) {
        return;
      }

      let pageSelected;
      // Dynamically select the page based on tabName and entityType
      if (entityType?.Metric === "Truckloads_Projected") {
        pageSelected = pages[4];
      } else if (
        entityType?.Metric === "Cost_Reduction" &&
        entityType?.Module !== "SNO" &&
        entityType?.Module !== "DOM"
      ) {
        pageSelected = pages[1];
      } else if (entityType?.Metric === "Past_due_STO") {
        pageSelected = entityType?.Module === "DO" ? pages[5] : pages[6];
      } else if (
        entityType?.Metric === "Cost_Reduction" &&
        entityType?.Module === "SNO"
      ) {
        pageSelected = pages[8];
      } else if (
        entityType?.Metric === "Cost_Reduction" &&
        entityType?.Module === "DOM"
      ) {
        pageSelected = pages[9];
      } else if (
        ["Pending action > 2 days"].includes(entityType?.Metric) &&
        entityType?.Module === "DETENTION"
      ) {
        pageSelected = pages[3];
      } else if (
        [
          "Incident rate increase WoW",
          "Pending action > 2 days",
          "Incident rate increase MoM",
        ].includes(entityType?.Metric)
      ) {
        pageSelected = pages[2];
      } else if (
        (entityType?.Metric === "LT-Over Utilization" ||
          entityType?.Metric === "LT-Under Utilization") &&
        (entityType?.Module === "CP" || entityType?.Module === "DRP")
      ) {
        if (entityType?.Network?.toUpperCase() === "AMBIENT") {
          pageSelected = pages[18];
        } else if (entityType?.Network?.toUpperCase() === "FROZEN") {
          pageSelected = pages[78];
        } else if (entityType?.Network?.toUpperCase() === "CHILLED") {
          pageSelected = pages[70];
        } else if (entityType?.Network?.toUpperCase() === "NPW") {
          pageSelected = pages[47];
        }
      } else if (
        (entityType?.Metric === "ST-Over Utilization" ||
          entityType?.Metric === "ST-Under Utilization" ||
          entityType?.Metric === "Throughput") &&
        (entityType?.Module === "CP" || entityType?.Module === "DRP")
      ) {
        if (entityType?.Network?.toUpperCase() === "AMBIENT") {
          pageSelected = pages[4];
        } else if (entityType?.Network?.toUpperCase() === "FROZEN") {
          pageSelected = pages[75];
        } else if (entityType?.Network?.toUpperCase() === "CHILLED") {
          pageSelected = pages[65];
        } else if (entityType?.Network?.toUpperCase() === "NPW") {
          pageSelected = pages[29];
        }
      } else if (
        entityType?.Metric === "Waste Risk" &&
        entityType?.Module === "DRP"
      ) {
        pageSelected = pages[14];
      } else if (
        selectedPowerData.selectedPowerData === "Recommended STRs for today" ||
        selectedPowerData.selectedPowerData === "Recommended TLs today" ||
        selectedPowerData.selectedPowerData === "STRs Required" ||
        selectedPowerData.selectedPowerData === "TLs This Month" ||
        selectedPowerData.selectedPowerData === "STRs To Cancel"
      ) {
        pageSelected = pages[3];
      } else if (
        selectedPowerData.selectedPowerData === "Past due STOs from 28 days" ||
        selectedPowerData.selectedPowerData === "Past Due STOs"
      ) {
        pageSelected = pages[6];
      } else if (store?.viewPowerBi?.deepDriveTab === "CP Main Report") {
        pageSelected = pages[0];
      } else if (store?.viewPowerBi?.deepDriveTab === "RDP") {
        pageSelected = pages[10];
      } else if (store?.viewPowerBi?.deepDriveTab === "RDP Frozen") {
        pageSelected = pages[0];
      } else if (store?.viewPowerBi?.deepDriveTab === "RDP NPW") {
        pageSelected = pages[0];
      } else if (store?.viewPowerBi?.deepDriveTab === "RDP Chilled") {
        pageSelected = pages[0];
      } else {
        pageSelected = getPageBasedOnTabAndEntity(tabName, entityType, pages);
      }

      if (!pageSelected) {
        return;
      }

      await pageSelected.setActive();

      const visuals = await pageSelected.getVisuals();
      console.log(" pageSelected ", pageSelected);
      if (!visuals) {
        return;
      }
      const allPageFilters = await report.getFilters();
      const currentPageFilters = await pageSelected.getFilters();
      console.log(
        "currentPageFilterscurrentPageFilters>>>>>>>>>>>, allPageFilters",
        currentPageFilters,
        allPageFilters,
      );
      const slicersVisuals = visuals.filter(
        (visual) => visual.type === "slicer",
      );
      // console.log("slicersVisuals ", slicersVisuals);
      // if (slicersVisuals.length === 0) {
      //   return;
      // }

      // console.log("slicersVisuals ", slicersVisuals);
      // Fetch all slicer states
      const slicerStates = await Promise.all(
        slicersVisuals.map(async (slicer, _index) => {
          const res = await slicer.getSlicerState();
          return { slicer, state: res };
        }),
      );

      // console.log(
      //   "slicersVisuals, slicerStates ",
      //   slicersVisuals,
      //   slicerStates
      // );
      // console.log(slicerStates, visuals, tabName, entityType, pages, "PBI");
      switch (tabName) {
        case "DOM":
          await handleDOMTab(
            slicerStates,
            currentPageFilters,
            pageSelected,
            allPageFilters,
            report,
          );
          break;
        case "SNO":
          await handleSNOTab(
            slicerStates,
            currentPageFilters,
            pageSelected,
            allPageFilters,
            // report
          );
          break;
        case "Deployment Optimization":
          await handleDeploymentOptimizationTab(
            slicerStates,
            currentPageFilters,
            pageSelected,
            allPageFilters,
            report,
          );
          break;
        case "Deployment Planning":
          await handleDeploymentPlanningTab(
            slicerStates,
            currentPageFilters,
            pageSelected,
            allPageFilters,
            report,
          );
          break;
        case "Capacity Planning":
        case "CP":
          await handleCPDIPTab(slicerStates);
          break;
        case "FGS":
          await handleFGSTab(slicerStates);
          break;
        case "DIP":
        case "Distribution_Planning":
          await handleCPDIPTab(slicerStates);
          break;
        case "Potential Out Of Stock":
        case "POOS":
          await handlePOOSTab(
            slicerStates,
            currentPageFilters,
            pageSelected,
            allPageFilters,
            report,
          );
          break;
        case "FF":
          await handleFFTab(slicerStates);
          break;
        case "RR":
          await handleRRTab(slicerStates);
          break;
        case "NPS":
          await handleNPSTab(slicerStates);
          break;
        case "DETENTION":
          await handleDETENTIONTab(
            slicerStates,
            currentPageFilters,
            pageSelected,
            allPageFilters,
            report,
          );
          break;
        case "SLP":
          await handleSLPTab(slicerStates);
          break;
        case "IOFPB":
          await handleIOFPBTab(slicerStates);
          break;
        default:
      }
    } catch (error) {
      console.error("44. Error in setting slicers:", error);
    }
  }
  const getMetricValue = (value) => {
    switch (value) {
      case "NPOOS-Others":
      case "RPOOS-Others":
        return "Other";
      case "NPOOS-Pending Review":
      case "RPOOS-Pending Review":
        return "Pending Review";
      case "NPOOS-DM: Demand Planning Issue":
      case "RPOOS-DM: Demand Planning Issue":
      case "RPOOS-DM: Demand Planning Issues":
      case "NPOOS-DM: Demand Planning Issues":
        return "DM";
      case "RPOOS-CX: Capacity constraints":
        return "CX: Capacity constraints";
      case "RPOOS-FQ: FG Quality Failures":
        return "FQ: FG Quality Failures";
      case "RPOOS-BD: Business Decision":
        return "BD: Business Decision";
      case "RPOOS-MF: Non FG failures":
        return "MF: Non FG failures";
      case "RPOOS-SX: Supply Planning errors":
        return "SX: Supply Planning errors";
      case "RPOOS-EI: Event Planning issues":
        return "EI: Event Planning issues";
      case "RPOOS-3E: Network Constraints":
        return "3E: Network Constraints";
      case "NPOOS-FQ: FG Quality Failures":
        return "FQ: FG Quality Failures";
      case "NPOOS-3C: Late Inbound":
        return "3C: Late Inbound";
      case "NPOOS-MF: Non FG failures":
        return "MF: Non FG failures";
    }
  };
  // Helper function to determine the page based on tabName and entityType
  function getPageBasedOnTabAndEntity(tabName, entityType, pages) {
    if (!pages || pages.length < 4) {
      console.error("Pages data is incomplete.");
      return null;
    }

    if (module === "SLP") {
      return pages[1];
    }

    switch (tabName) {
      case "DOM":
        return pages[10];
      case "SNO":
        if (entityType?.Metric === "cost_per_case") {
          return pages[53];
        } else {
          return pages[7];
        }
      case "DETENTION":
        if (entityType?.Metric === "MOM") {
          return pages[1];
        }
      case "Deployment Optimization":
        if (entityType?.Metric === "Past_due_STO") {
          return pages[5];
        } else if (entityType?.Metric === "Rejected_STR") {
          return pages[3];
        }

      case "FF":
        if (entityType?.Delivery_type === "DELIVERY") {
          if (entityType?.Network === "FROZEN") {
            return pages[14];
          } else if (
            entityType?.Network === "CHILLED" &&
            entityType?.Temperature === "CHILLED"
          ) {
            return pages[8];
          } else if (
            entityType?.Network === "AMBIENT" &&
            entityType?.Temperature === "TEMPCONTROLLED"
          ) {
            return pages[5];
          } else if (
            entityType?.Network === "AMBIENT" &&
            entityType?.Temperature === "AMBIENT"
          ) {
            return pages[3];
          } else if (
            entityType?.Network === "CHILLED" &&
            entityType?.Temperature === "AMBIENT"
          ) {
            return pages[13];
          } else if (
            entityType?.Network === "CHILLED" &&
            entityType?.Temperature === "TEMPCONTROLLED"
          ) {
            return pages[10];
          }
        } else {
          if (entityType?.Network === "FROZEN") {
            return pages[13];
          } else if (
            entityType?.Network === "CHILLED" &&
            entityType?.Temperature === "CHILLED"
          ) {
            return pages[7];
          } else if (
            entityType?.Network === "AMBIENT" &&
            entityType?.Temperature === "TEMPCONTROLLED"
          ) {
            return pages[4];
          } else if (
            entityType?.Network === "AMBIENT" &&
            entityType?.Temperature === "AMBIENT"
          ) {
            return pages[2];
          } else if (
            entityType?.Network === "CHILLED" &&
            entityType?.Temperature === "AMBIENT"
          ) {
            return pages[6];
          } else if (
            entityType?.Network === "CHILLED" &&
            entityType?.Temperature === "TEMPCONTROLLED"
          ) {
            return pages[9];
          }
        }
      case "Deployment Planning":
        return pages[19];
      case "Capacity Planning":
      case "Distribution_Planning":
        return pages[1];
      case "FGS":
        if (entityType?.Metric === "Waste Risk") {
          return pages[16];
        } else {
          return pages[3];
        }
      case "Potential Out Of Stock":
      case "POOS":
        if (
          entityType?.Metric === "NPOOS-Reject" ||
          entityType?.Metric === "NPOOS-Pending Review" ||
          entityType?.Metric === "NPOOS-Others" ||
          entityType?.Metric === "NPOOS-FQ: FG Quality Failures" ||
          entityType?.Metric === "NPOOS-DM: Demand Planning Issue" ||
          entityType?.Metric === "NPOOS-DM: Demand Planning Issues" ||
          entityType?.Metric === "NPOOS-FQ: FG Quality Failures" ||
          entityType?.Metric === "NPOOS-3C: Late Inbound" ||
          entityType?.Metric === "NPOOS-MF: Non FG failures"
        ) {
          if (entityType?.Is_active === "1") {
            return pages[4];
          } else if (
            entityType?.Is_active === "0" ||
            entityType?.Is_active === "2"
          ) {
            return pages[6];
          }
        } else if (
          entityType?.Metric === "RPOOS-Reject" ||
          entityType?.Metric === "RPOOS-Pending Review" ||
          entityType?.Metric === "RPOOS-Others" ||
          entityType?.Metric === "RPOOS-FQ: FG Quality Failures" ||
          entityType?.Metric === "RPOOS-DM: Demand Planning Issue" ||
          entityType?.Metric === "RPOOS-DM: Demand Planning Issues" ||
          entityType?.Metric === "RPOOS-CX: Capacity constraints" ||
          entityType?.Metric === "RPOOS-FQ: FG Quality Failures" ||
          entityType?.Metric === "RPOOS-BD: Business Decision" ||
          entityType?.Metric === "RPOOS-MF: Non FG failures" ||
          entityType?.Metric === "RPOOS-SX: Supply Planning errors" ||
          entityType?.Metric === "RPOOS-EI: Event Planning issues" ||
          entityType?.Metric === "RPOOS-3E: Network Constraints"
        ) {
          if (entityType?.Is_active === "1") {
            return pages[4];
          } else if (
            entityType?.Is_active === "0" ||
            entityType?.Is_active === "2"
          ) {
            return pages[5];
          }
        }

      case "NPS":
        if (entityType?.Metric === "Capacity Breach") {
          return pages[8];
        } else if (entityType?.Metric === "Cost Increase vs Baseline") {
          return pages[2];
        } else if (entityType?.Metric === "Revenue Decrease vs Baseline") {
          return pages[2];
        } else {
          return pages[7];
        }

      case "RR":
        return pages[1];

      case "IOFPB":
        if (entityType?.Metric === "Cancellations - above Upper limit") {
          return pages[29];
        } else if (entityType?.Metric === "Exceptions - above Upper limit'") {
          return pages[30];
        } else {
          return pages[32];
        }
      case "SLP":
        return pages[2];

      default:
        console.error("No page selection logic for this tab.");
        return null;
    }
  }

  async function handleIOFPBTab(_slicerStates) {
    const report = window?.report;

    if (entityType.Entity === "Manager") {
      const filter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Cancellation_reason_order_value",
          column: "Manager_Name",
        },
        operator: "In",
        values: [entityType?.Name],
      };

      try {
        const pages = await report.getPages();
        // Retrieve the active page.
        let page = pages.filter(function (page) {
          return page.isActive;
        })[0];

        await page.updateFilters(models.FiltersOperations.Add, [filter]);
        console.log("Page filter was added.");
      } catch (errors) {
        console.log(errors);
      }
    } else {
      const filter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Cancelled_Reasons_Count_day_level_cl6_csm",
          column: "CustomerLevel6PlanningAccountDescription",
        },
        operator: "In",
        values: [entityType?.Name],
      };

      try {
        const pages = await report.getPages();
        // Retrieve the active page.
        let page = pages.filter(function (page) {
          return page.isActive;
        })[0];

        await page.updateFilters(models.FiltersOperations.Add, [filter]);
        console.log("Page filter was added.");
      } catch (errors) {
        console.log(errors);
      }
    }
  }

  // async function handleTab(slicerStates, columnMap, defaultError) {
  //   const { Entity, Name } = entityType || {};
  //   const column = columnMap[Entity] || columnMap.default;
  //   const slicer = slicerStates.find(
  //     ({ state }) => state.targets[0].column === column
  //   );

  //   if (slicer) {
  //     await slicer.slicer.setSlicerState({
  //       filters: [
  //         {
  //           $schema: "http://powerbi.com/product/schema#basic",
  //           filterType: 1,
  //           operator: "In",
  //           requireSingleSelection: false,
  //           target: slicer.state.targets[0],
  //           values: [Name],
  //         },
  //       ],
  //     });
  //   } else {
  //     console.error(defaultError);
  //   }
  // }

  async function handleDOMTab(
    _slicerStates,
    currentPageFilters,
    pageSelected,
    allPageFilters,
    report,
  ) {
    console.log(
      "currentPageFilters,    pageSelected,    allPageFilters,    report",
      currentPageFilters,
    );
    if (entityType?.Entity === "Network") {
      const tempSlicer = allPageFilters.find(
        (item) => item.target.column === "Network",
      );
      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };
      try {
        await report.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    } else {
      console.error("Entity Not Found.");
    }
    if (entityType?.Entity === "DC") {
      const tempSlicer = currentPageFilters.find(
        (item) => item.target.column === "DefaultDC",
      );
      console.log("tempSlicer", tempSlicer);
      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        displaySettings: { displayName: "Default DC" },
        target: { table: "SKU Level", column: "DefaultDC" },
        operator: "In",
        values: ["All"],
        requireSingleSelection: true,
        filterType: 1,
      };
      console.log(
        "tempFilter>>>>>>>>",
        tempFilter,
        models.FilterType.BasicFilter,
      );
      pageSelected.getFilters().then((filters) => console.log(filters));

      try {
        await pageSelected.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
        // pageSelected
        //   .getFilters()
        //   .then((filters) =>
        //     console.log(displaySettings?.displayName === "Default DC"),
        //   );
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    } else {
      console.error("Entity Not Found.");
    }
    // await handleTab(
    //   slicerStates,
    //   { DC: "RecommendedDC", default: "Network" },
    //   "No Network slicer found for DOM."
    // );
  }

  async function handleNPSTab(slicerStates) {
    const verdictSlicer = slicerStates.find(
      (item) => item.state.targets[0].column === "ScenarioName",
    );
    if (verdictSlicer) {
      const verdictFilter = [
        {
          $schema: "http://powerbi.com/product/schema#basic",
          filterType: 1,
          operator: "In",
          requireSingleSelection: false,
          target: verdictSlicer.state.targets[0],
          values: [entityType?.ScenarioName],
        },
      ];
      await verdictSlicer.slicer.setSlicerState({ filters: verdictFilter });
    } else {
      console.error("Verdict Not Found.");
    }
  }

  async function handleDETENTIONTab(
    _slicerStates,
    currentPageFilters,
    page,
    _allPageFilters,
    _report,
  ) {
    console.log(
      "currentPageFilters inside detention>>>>>>>>>>>>",
      currentPageFilters,
    );
    if (entityType?.Entity === "Facility") {
      const locationSlicer = currentPageFilters.find(
        (item) => item.target.column === "Accessorial_LocationID",
      );

      const locationFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        displaySettings: { displayName: "Accessorial Location ID" },
        target: locationSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };
      await page.updateFilters(models.FiltersOperations.Replace, [
        locationFilter,
      ]);
    }
    if (
      entityType?.Entity === "Location Type" ||
      entityType?.Entity === "Location_type"
    ) {
      const facilitySlicer = currentPageFilters.find(
        (item) => item.target.column === "Accessorial_facilityType",
      );

      if (facilitySlicer) {
        // const facilityFilter = {
        //   $schema: "http://powerbi.com/product/schema#basic",
        //   target: facilitySlicer.target,
        //   operator: "In",
        //   values: [entityType?.Name],
        //   filterType: models.FilterType.BasicFilter,
        // };
        // await page.updateFilters(models.FiltersOperations.Replace, [
        //   facilityFilter,
        // ]);
        const filter = [
          {
            $schema: "http://powerbi.com/product/schema#basic",
            displaySettings: { displayName: "Accessorial Facility Type" },
            filterType: 1,
            operator: "In",
            requireSingleSelection: false,
            target: { table: "Recon", column: "Accessorial_facilityType" },
            values: [entityType?.Name],
          },
          // {
          //   $schema: "http://powerbi.com/product/schema#basic",
          //   displaySettings: { displayName: "AP Action Date" },
          //   filterType: 1,
          //   operator: "In",
          //   requireSingleSelection: false,
          //   target: { table: "Recon", column: "AP_modified_date" },
          //   values: [null],
          // },
        ];
        await page.updateFilters(models.FiltersOperations.Replace, filter);
      } else {
        console.error("Facility Not Found.");
      }
    }
    const locationSlicer = currentPageFilters.find(
      (item) => item.target.column === "AP_Modified_Status",
    );
    console.log("locationSlicerlocationSlicer", locationSlicer);
    const locationFilter = {
      $schema: "http://powerbi.com/product/schema#basic",
      displaySettings: { displayName: "AP Validation" },
      target: locationSlicer.target,
      operator: "In",
      values: ["No"],
      filterType: models.FilterType.BasicFilter,
    };
    await page.updateFilters(models.FiltersOperations.Replace, [
      locationFilter,
    ]);
    // const shipDateSlicer = slicerStates.find(
    //   (item) => item.state.targets[0].column === "Year"
    // );
    // const report = window?.report;
    // const ShipDateFilter = {
    //   $schema: "http://powerbi.com/product/schema#advanced",
    //   target: {
    //     table: "RCA Historic",
    //     column: "GoodsIssueDate",
    //   },
    //   filterType: 0,
    //   logicalOperator: "And",
    //   conditions: [
    //     {
    //       operator: "GreaterThanOrEqual",
    //       value: "2023-03-30T18:30:00.000Z",
    //     },
    //     {
    //       operator: "LessThan",
    //       value: "2025-01-30T18:30:00.000Z",
    //     },
    //   ],
    // };
    // await report.setFilters([ShipDateFilter]);
  }

  async function handleCPDIPTab(slicerStates) {
    if (entityType?.Entity === "Network") {
      const tempSlicer = slicerStates.find(
        (item) => item.state.targets[0].column?.toLowerCase() === "network",
      );
      if (tempSlicer) {
        const tempFilter = [
          {
            $schema: "http://powerbi.com/product/schema#basic",
            filterType: 1,
            operator: "In",
            requireSingleSelection: false,
            target: tempSlicer.state.targets[0],
            values: [entityType?.Name],
          },
        ];

        await tempSlicer.slicer.setSlicerState({ filters: tempFilter });
      } else {
        console.error("Entity Not Found.");
      }
    } else if (entityType?.Entity === "DC") {
      const tempSlicer = slicerStates.find(
        (item) => item.state.targets[0].column?.toLowerCase() === "location",
      );
      if (tempSlicer) {
        const tempFilter = [
          {
            $schema: "http://powerbi.com/product/schema#basic",
            filterType: 1,
            operator: "In",
            requireSingleSelection: false,
            target: tempSlicer.state.targets[0],
            values: [entityType?.Name],
          },
        ];

        await tempSlicer.slicer.setSlicerState({ filters: tempFilter });
      } else {
        console.error("Entity Not Found.");
      }
    }
  }

  async function handlePOOSTab(
    slicerStates,
    currentPageFilters,
    page,
    allPageFilters,
    report,
  ) {
    console.log("slicerStates>>>>>>>>>>>>", slicerStates);
    if (entityType?.Entity === "Network") {
      const tempSlicer = allPageFilters.find(
        (item) => item.target.column === "Network",
      );
      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };
      try {
        await report.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    } else {
      console.error("Entity Not Found.");
    }
    if (entityType?.Entity === "MaterialID") {
      const tempSlicer = allPageFilters.find(
        (item) => item.target.column === "MaterialID",
      );

      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };
      try {
        await report.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    } else {
      console.error("Entity Not Found.");
    }
    if (entityType?.Entity === "Division") {
      const tempSlicer = allPageFilters.find(
        (item) => item.target.column === "Division",
      );

      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };
      try {
        await report.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    } else {
      console.error("Entity Not Found.");
    }
    if (entityType?.Entity === "PL3") {
      const tempSlicer = allPageFilters.find(
        (item) => item.target.column === "ProductLevel3CategoryDescription",
      );
      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };

      try {
        await report.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    }
    if (entityType.Metric.includes("Reject")) {
      const replacement = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: { table: "RPOOS_PlannerActions", column: "Verdict" },
        operator: "In",
        values: ["disagree"],
        filterType: models.FilterType.BasicFilter,
      };

      await page.updateFilters(models.FiltersOperations.Replace, [replacement]);
    }
    // if (entityType?.PL3) {
    //   const tempSlicer = allPageFilters.find(
    //     (item) => item.target.column === "ProductLevel3CategoryDescription"
    //   );
    //   const tempFilter = {
    //     $schema: "http://powerbi.com/product/schema#basic",
    //     target: tempSlicer.target,
    //     operator: "In",
    //     values: [entityType?.Name],
    //     filterType: models.FilterType.BasicFilter,
    //   };

    //   try {
    //     await report.updateFilters(models.FiltersOperations.Replace, [
    //       tempFilter,
    //     ]);
    //   } catch (err) {
    //     console.log("errr>>>>>>>>>.", err);
    //   }
    // }
    if (
      (entityType.Metric !== "Reject" || entityType.Metric !== "Accept") &&
      entityType.Is_active === "1"
    ) {
      const tempSlicer = currentPageFilters.find(
        (item) => item.target.column === "ReasonCode",
      );

      const value =
        getMetricValue(entityType?.Metric) === "DM"
          ? ["DM"]
          : ["3C", "3E", "BD", "CX", "FQ", "MF", "PX", "SX"];

      const replacement = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: value,
        filterType: models.FilterType.BasicFilter,
      };
      await page.updateFilters(models.FiltersOperations.Replace, [replacement]);
    }
    if (entityType.Is_active === "1") {
      const verdictSlicer = slicerStates.find(
        (item) => item.state.targets[0].column === "RegionalVsNational",
      );
      const firstChar = entityType.Metric.charAt(0);
      const flag = firstChar === "N" ? "National" : "Regional";
      console.log("verdictSlicer firstChar", verdictSlicer, firstChar);
      if (verdictSlicer) {
        const verdictFilter = [
          {
            $schema: "http://powerbi.com/product/schema#basic",
            filterType: 1,
            operator: "In",
            requireSingleSelection: false,
            target: verdictSlicer.state.targets[0],
            values: [flag],
          },
        ];
        await verdictSlicer.slicer.setSlicerState({ filters: verdictFilter });
      } else {
        console.error("Verdict Not Found.");
      }
    }
  }

  async function handleSLPTab(_slicerStates) {
    const report = window?.report;
    console.log("entity Type>>>>>>>>>>>>>>", entityType);
    const powerBiColumnTableMapping = {
      SKU: {
        table: "Model",
        column: "SKU",
      },
      CL4: {
        table: "Model",
        column: "CL4",
      },
      DC: {
        table: "Model",
        column: "Plant",
      },
      Network: {
        table: "Model",
        column: "Network",
      },
    };

    const powerBiSLPAlertTypeMapping = {
      "Confirm qty adjustment":
        "Adjust Confirmed Quantities from Future Orders",
      "Low Payload or COF": "Low Payload or COF Found, Contact OM Team",
      "ATP To confirm Quantity": "Allocate the ATP to Confirmed Quantity",
    };

    let filter;
    let metricFilter;

    if (entityType.Entity && entityType?.Name) {
      filter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: powerBiColumnTableMapping[entityType.Entity],
        operator: "In",
        values: [entityType?.Name],
      };
    }
    if (entityType.Metric && powerBiSLPAlertTypeMapping[entityType.Metric]) {
      metricFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Model",
          column: "InFull Model Recommendations",
        },
        operator: "In",
        values: [powerBiSLPAlertTypeMapping[entityType.Metric]],
      };
    }
    const filterToBeApplied = [
      ...(filter ? [filter] : []),
      ...(metricFilter ? [metricFilter] : []),
    ];

    try {
      const pages = await report.getPages();
      // Retrieve the active page.
      let page = pages.filter(function (page) {
        return page.isActive;
      })[0];

      await page.updateFilters(
        models.FiltersOperations.Replace,
        filterToBeApplied,
      );
      console.log("Page filter was added.");
    } catch (errors) {
      console.log(errors);
    }
  }

  function getWeek(date) {
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const pastDaysOfYear = (date - startOfYear) / 86400000;
    return Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);
  }

  async function setSlicerState(
    slicerStates,
    column,
    value,
    errorMessage,
    otherFilter = false,
  ) {
    console.log("slicerStates", slicerStates);
    const slicer = slicerStates.find(
      ({ state }) => state.targets[0].column === column,
    );
    if (slicer) {
      if (!otherFilter) {
        await slicer.slicer.setSlicerState({
          filters: [
            {
              $schema: "http://powerbi.com/product/schema#basic",
              filterType: 1,
              operator: "In",
              requireSingleSelection: false,
              target: slicer.state.targets[0],
              values: [value],
            },
          ],
        });
      } else {
        await slicer.slicer.setSlicerState({
          filters: [
            {
              $schema: "http://powerbi.com/product/schema#relativeDate",
              filterType: 4,
              includeToday: true,
              operator: 0,
              target: { table: "SAP OVT Data", column: "Ship Date" },
              timeUnitType: 0,
              timeUnitsCount: 14,
            },
          ],
        });
      }
    } else {
      console.error(errorMessage);
    }
  }

  async function handleRRTab(_slicerStates) {
    const report = window?.report;

    if (entityType.Entity === "DC") {
      const dcFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        filterType: 1, // BasicFilter
        operator: "In",
        target: {
          table: "customer order divert",
          column: "RecommendedDC",
        },
        values: [entityType.Name], // Filter for the specified network
      };

      const networkFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        filterType: 1, // BasicFilter
        operator: "In",
        target: {
          table: "customer order divert",
          column: "Network",
        },
        values: [entityType.Network], // Filter for the specified network
      };

      const scenarioFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        filterType: 1, // BasicFilter
        operator: "In",
        target: {
          table: "customer order divert",
          column: "ScenarioName",
        },
        values: [entityType.ScenarioName], // Filter for the specified network
      };

      await report.setFilters([dcFilter, networkFilter, scenarioFilter]);
    } else if (entityType.Entity === "Network") {
      const networkFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        filterType: 1, // BasicFilter
        operator: "In",
        target: {
          table: "customer order divert",
          column: "Network",
        },
        values: [entityType.Name], // Filter for the specified network
      };

      const scenarioFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        filterType: 1, // BasicFilter
        operator: "In",
        target: {
          table: "customer order divert",
          column: "ScenarioName",
        },
        values: [entityType.ScenarioName], // Filter for the specified network
      };

      await report.setFilters([networkFilter, scenarioFilter]);
    }
  }

  async function handleFFTab(_slicerStates) {
    if (!entityType) {
      return;
    }
    const { Delivery_type, Network, Temperature, Name, LaneId } = entityType;
    let table;
    const report = window?.report;

    const tableMapping = {
      DELIVERY: {
        FROZEN: "FR-FR-CS",
        CHILLED: {
          CHILLED: "CH-CH-CS",
          AMBIENT: "FR-FR-STO",
          TEMPCONTROLLED: "CH-TC-CS",
        },
        AMBIENT: {
          AMBIENT: "AM-AM-CS",
          TEMPCONTROLLED: "AM-TC-CS",
        },
      },
      default: {
        FROZEN: "FR-FR-STO",
        CHILLED: {
          CHILLED: "CH-CH-STO",
          AMBIENT: "CH-AM-STO",
          TEMPCONTROLLED: "CH-TC-STO",
        },
        AMBIENT: {
          AMBIENT: "AM-AM-STO",
          TEMPCONTROLLED: "AM-TC-STO",
        },
      },
    };

    table =
      tableMapping[Delivery_type]?.[Network] ?? tableMapping.default[Network];

    if (typeof table === "object") {
      table = table[Temperature];
    }

    if (LaneId !== null && table) {
      const networkFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        filterType: 1, // BasicFilter
        operator: "In",
        target: {
          table,
          column: "LaneID",
        },
        values: [Name], // Filter for the specified network
      };
      await report.setFilters([networkFilter]);
    }
  }

  async function handleSNOTab(
    slicerStates,
    currentPageFilters,
    pageSelected,
    allPageFilters,
    // report
  ) {
    console.log(
      "currentPageFilters,pageSelected,allPageFilters,report>>>>>>>>>>>sno",
      currentPageFilters,
      pageSelected,
      allPageFilters,
      // report
    );

    const { Entity, Name, Genrated_date, Formatted_Location } =
      entityType || {};
    const date = new Date(Genrated_date || new Date());
    const today = new Date().toISOString();
    const report = window?.report;
    // const specificDate = new Date("2025-02-01").toISOString(); // Specific date in ISO format
    let networkFilter = null;
    if (entityType?.Metric === "cost_per_case") {
      console.log("Formatted_Location", Formatted_Location);
      if (Entity === "DC") {
        await setSlicerState(
          slicerStates,
          "Origin Location TM",
          Formatted_Location,
          "No Origin Location TM slicer found for SNO.",
        );
      } else {
        // const shipDateFilter = {
        //   $schema: "http://powerbi.com/product/schema#advanced",
        //   filterType: 0, // AdvancedFilter
        //   logicalOperator: "And",
        //   target: {
        //     table: "SAP OVT Data",
        //     column: "Ship Date",
        //   },
        //   conditions: [
        //     {
        //       operator: "LessThan",
        //       value: specificDate, // Filter for dates less than February 1, 2025
        //     },
        //   ],
        // };
        networkFilter = {
          $schema: "http://powerbi.com/product/schema#basic",
          filterType: 1, // BasicFilter
          operator: "In",
          target: {
            table: "Origin Locations",
            column: "Network",
          },
          values: [entityType.Name], // Filter for the specified network
        };
      }
      await setSlicerState(
        slicerStates,
        "Load Type",
        "Delivery",
        "No Load Type slicer found for SNO.",
      );
      await setSlicerState(
        slicerStates,
        "Ship Date",
        "",
        "No Ship Date slicer found for SNO.",
        true,
      );
      const loadType = {
        $schema: "http://powerbi.com/product/schema#advanced",
        filterType: 1,
        operator: "In",
        target: {
          table: "SAP OVT Data",
          column: "Load Type",
        },
        values: ["Delivery"],
      };
      await report.setFilters([networkFilter]);
      await pageSelected.updateFilters(models.FiltersOperations.Replace, [
        loadType,
      ]);
    } else {
      if (Entity === "Network") {
        await setSlicerState(
          slicerStates,
          "Network",
          Name,
          "No Network slicer found for SNO.",
        );
      }
      await setSlicerState(
        slicerStates,
        "Year",
        date.getFullYear(),
        "No Year slicer found for SNO.",
      );
      await setSlicerState(
        slicerStates,
        "WeekOfYear",
        getWeek(date),
        "No WeekOfYear slicer found for SNO.",
      );
      await setSlicerState(
        slicerStates,
        "Month",
        String(date.getMonth() + 1).padStart(2, "0"),
        "No Month slicer found for SNO.",
      );
    }
    const dateSlicer = slicerStates.find(
      ({ state }) => state.targets[0].column === "Date",
    );
    if (dateSlicer) {
      await dateSlicer.slicer.setSlicerState({
        filters: [
          {
            $schema: "http://powerbi.com/product/schema#advanced",
            filterType: 0,
            logicalOperator: "And",
            target: dateSlicer.state.targets[0],
            conditions: [{ operator: "LessThan", value: today }],
          },
        ],
      });
    } else {
      console.error("No Date slicer found for SNO.");
    }
  }

  async function handleDeploymentOptimizationTab(
    _slicerStates,
    currentPageFilters,
    pageSelected,
    _allPageFilters,
    _report,
  ) {
    // const { Entity, Metric, Name } = entityType || {};

    // const setSlicerState = async (
    //   column,
    //   values,
    //   errorMessage = `No ${column} slicer found.`,
    // ) => {
    //   const slicer = slicerStates.find(
    //     ({ state }) => state.targets[0].column === column,
    //   );
    //   if (slicer) {
    //     await slicer.slicer.setSlicerState({
    //       filters: [
    //         {
    //           $schema: "http://powerbi.com/product/schema#basic",
    //           filterType: 1,
    //           operator: "In",
    //           requireSingleSelection: false,
    //           target: slicer.state.targets[0],
    //           values,
    //         },
    //       ],
    //     });
    //   } else {
    //     console.error(errorMessage);
    //   }
    // };

    // if (
    //   Metric === "Past_due_STO" &&
    //   (Entity === "Network" || Entity === "Product")
    // ) {
    //   await setSlicerState(Entity === "Network" ? "Network" : "MaterialID", [
    //     Name,
    //   ]);
    //   return;
    // }

    // await Promise.all([
    //   setSlicerState("Network", []),
    //   setSlicerState("Reason_for_rejection", []),
    // ]);

    // const entitySlicerMap = {
    //   Network: "Network",
    //   Product: "MaterialID",
    //   DC: "DestinationLocationID",
    // };

    // if (entitySlicerMap[Entity]) {
    //   await setSlicerState(entitySlicerMap[Entity], [Name]);
    // }

    // if (Metric !== "Rejected_STR") {
    //   await setSlicerState("Reason_for_rejection", ["STRs Accepted"]);
    // } else {
    //   let filteredValues;
    //   if (Name === "AMBIENT") {
    //     filteredValues = ["Sufficient Inventory Cover at Destination"];
    //   } else if (Name === "CHILLED") {
    //     filteredValues = [
    //       "Sufficient Inventory Cover at Destination",
    //       "Low Inventory at Origin",
    //     ];
    //   } else if (Name === "FROZEN") {
    //     filteredValues = [
    //       "Sufficient Inventory Cover at Destination",
    //       "Low Inventory at Origin",
    //       "Sufficient Inventory Cover at Destination",
    //     ];
    //   }
    //   console.log(Name, filteredValues, "filteredValues");

    //   await setSlicerState("Reason_for_rejection", filteredValues);
    // }

    if (entityType?.Entity === "Network") {
      const tempSlicer = currentPageFilters.find(
        (item) => item.target.column === "Network",
      );
      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };
      try {
        await pageSelected.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    } else {
      console.error("Entity Not Found.");
    }
    if (entityType?.Entity === "MaterialID") {
      const tempSlicer = currentPageFilters.find(
        (item) => item.target.column === "MaterialID",
      );
      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };
      try {
        await pageSelected.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    } else {
      console.error("Entity Not Found.");
    }
  }

  async function handleDeploymentPlanningTab(
    _slicerStates,
    currentPageFilters,
    pageSelected,
    _allPageFilters,
    _report,
  ) {
    console.log("inside dpppppppppppppppp", currentPageFilters);
    // const { Entity, Metric, Name } = entityType || {};
    // const entitySlicerMap = {
    //   Network: "Network",
    //   Product: "MaterialID",
    //   DC: "DestinationLocationID",
    // };

    // if (Entity === "Division") {
    //   await setSlicerState(
    //     slicerStates,
    //     "Network",
    //     [],
    //     "No Network slicer found.",
    //   );
    //   return;
    // }

    // if (
    //   ["Truckloads_Projected", "Cost_Reduction"].includes(Metric) &&
    //   entitySlicerMap[Entity]
    // ) {
    //   await setSlicerState(
    //     slicerStates,
    //     entitySlicerMap[Entity],
    //     Name,
    //     `No ${entitySlicerMap[Entity]} slicer found.`,
    //   );
    // }
    if (entityType?.Entity === "Network") {
      const tempSlicer = currentPageFilters.find(
        (item) => item.target.column === "Network",
      );
      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };
      try {
        await pageSelected.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    } else {
      console.error("Entity Not Found.");
    }
    if (entityType?.Entity === "MaterialID") {
      const tempSlicer = currentPageFilters.find(
        (item) => item.target.column === "MaterialID",
      );
      const tempFilter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: tempSlicer.target,
        operator: "In",
        values: [entityType?.Name],
        filterType: models.FilterType.BasicFilter,
      };
      try {
        await pageSelected.updateFilters(models.FiltersOperations.Replace, [
          tempFilter,
        ]);
      } catch (err) {
        console.log("errr>>>>>>>>>.", err);
      }
    } else {
      console.error("Entity Not Found.");
    }
  }

  async function handleFGSTab(slicerStates) {
    const { Metric, Entity, Name, Network, PL3, Division } = entityType || {};
    const report = window?.report;

    if (Entity === "Division") {
      const filter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          column: "Division",
          table: "Material MD",
        },
        operator: "In",
        values: [Division],
      };

      try {
        const pages = await report.getPages();
        // Retrieve the active page.
        let page = pages.filter(function (page) {
          return page.isActive;
        })[0];

        await page.updateFilters(models.FiltersOperations.Add, [filter]);
        console.log("Page filter was added.");
      } catch (errors) {
        console.log(errors);
      }
    }

    if (Entity === "ProductLevel3" || Entity === "PL3") {
      const filterPL3 = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          column: "ProductLevel3CategoryDescription",
          table: "Material MD",
        },
        operator: "In",
        values: ["US REFRIGERATED COOKIE DOUGH"],
      };

      try {
        const pages = await report.getPages();
        // Retrieve the active page.
        let page = pages.filter(function (page) {
          return page.isActive;
        })[0];

        await page.updateFilters(models.FiltersOperations.Add, [filterPL3]);
        console.log("Page filter was added.");
      } catch (errors) {
        console.log(errors);
      }
    }
    if (Entity === "MaterialID") {
      const filter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          column: "MaterialID",
          table: "DistinctMaterialIDs",
        },
        operator: "In",
        values: [Name],
        filterType: models.FilterType.BasicFilter,
      };

      try {
        await report.updateFilters(models.FiltersOperations.Replace, [filter]);
      } catch (errors) {
        console.log(errors);
      }
    }
    if (Metric === "Waste Risk") {
      if (Entity === "ProductLevel3") {
        await setSlicerState(
          slicerStates,
          "ProductLevel3CategoryDescription",
          Network,
          "No ProductLevel3CategoryDescription slicer found.",
        );
        await setSlicerState(
          slicerStates,
          "Network",
          Network,
          "No Network slicer found.",
        );
      } else if (Entity === "MaterialID") {
        await setSlicerState(
          slicerStates,
          "Network",
          Network,
          "No Network slicer found.",
        );
        await setSlicerState(
          slicerStates,
          "ProductLevel3CategoryDescription",
          PL3,
          "No PL3 slicer found.",
        );
      } else if (Entity === "Network") {
        await setSlicerState(
          slicerStates,
          "Network",
          Name,
          "No Network slicer found.",
        );
      }
      // } else {
      //   if (Entity === "MaterialID" || Entity === "Network") {
      //     await setSlicerState(
      //       slicerStates,
      //       Entity === "MaterialID" ? "MaterialID" : "Network",
      //       Name,
      //       "No relevant slicer found."
      //     );
      //   }
    }
  }

  return (
    <div className={classes.fullScreenContainer}>
      {loading ? (
        <Loading />
      ) : (
        <PowerBIEmbed
          embedConfig={{
            type: "report",
            id: powerBIData?.reportId,
            embedUrl: powerBIData?.embedUrl,
            accessToken: powerBIData?.embedToken,
            tokenType: pbi.models.TokenType.Embed,
            permissions: pbi.models.Permissions.All,
            viewMode: pbi.models.ViewMode.View,
            settings: {
              panes: {
                filters: {
                  expanded: true,
                  visible: true,
                },
              },
              background: pbi.models.BackgroundType.Transparent,
            },
          }}
          eventHandlers={
            new Map([
              ["loaded", setSlicers],
              ["rendered", function () {}],
              [
                "error",
                function (event) {
                  console.log(event.detail);
                },
              ],
            ])
          }
          cssClassName={classes.embedContainer}
          getEmbeddedComponent={(embeddedReport) => {
            window.report = embeddedReport;
          }}
        />
      )}
    </div>
  );
};

export default PowerBIReportEmbed;
